import React from "react";
import { ClipboardList, Syringe, Sparkles, ArrowRight } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Get Approved",
    desc: "Share a few details. Dr. Shalini reviews your history, BMI, comorbidities and goals — online or in clinic.",
  },
  {
    n: "02",
    icon: Syringe,
    title: "Get Prescribed",
    desc: "Receive a personalised Mounjaro / GLP‑1 protocol with nutrition and movement guidance — medication home‑delivered.",
  },
  {
    n: "03",
    icon: Sparkles,
    title: "Begin Your Transformation",
    desc: "Weekly check‑ins on WhatsApp, dose titration, and side‑effect support. You're never alone in the journey.",
  },
];

export const GetStarted = ({ onBookClick }) => {
  return (
    <section id="get-started" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FCE9E2] px-3.5 py-1.5 text-xs font-semibold text-[#B84E38]">
            3 simple steps
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
            Start in under <em className="text-[#EB8771]">10 minutes</em>.
          </h2>
          <p className="mt-5 text-[#38312C] leading-relaxed">
            From eligibility check to your first supervised dose — we've made it calm, transparent and genuinely supportive.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 relative">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`get-started-${i}`}
              className="relative rounded-3xl bg-[#FAFAF7] border border-[#EAE7E1] p-8 hover:-translate-y-1 hover:border-[#779D7C]/30 transition-all"
            >
              <div className="flex items-center justify-between">
                <span className="font-display italic text-[#EB8771]">{s.n}</span>
                <div className="h-11 w-11 rounded-2xl bg-[#E8F0E9] grid place-items-center">
                  <s.icon className="h-5 w-5 text-[#779D7C]" strokeWidth={1.8} />
                </div>
              </div>
              <p className="font-display text-2xl mt-6 text-[#242220]">{s.title}</p>
              <p className="text-sm text-[#6B6660] mt-2 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            data-testid="getstarted-cta"
            onClick={onBookClick}
            className="inline-flex items-center gap-2 rounded-full bg-[#EB8771] hover:bg-[#E2725C] text-white px-8 py-4 text-[15px] font-medium shadow-[0_14px_30px_-14px_rgba(255,122,89,0.65)] transition-all hover:scale-[1.02]"
          >
            Take the Eligibility Quiz <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
